/**
 * Initialize Location Stock Data
 * 
 * This module synchronises location capacity and utilisation with actual stock items.
 * It should be called after stock items are generated to ensure location data is accurate.
 */

import { updateLocationStockFromItems, mockLocations } from "./mockWarehousesLocations";
import { StockItem } from "@/types/stock-item";

// This will be populated when stock items are generated
let initializedLocations = mockLocations;
let stockItemsCache: StockItem[] = [];

/**
 * Initialize locations with actual stock data from stock items
 * This should be called once when the app loads with the generated stock items
 */
export const initializeLocationsWithStockData = (stockItems: StockItem[]) => {
  stockItemsCache = stockItems;
  initializedLocations = updateLocationStockFromItems(mockLocations, stockItems);
  return initializedLocations;
};

/**
 * Get the initialized locations (with actual stock data)
 */
export const getInitializedLocations = () => {
  return initializedLocations;
};

/**
 * Helper function to get stock items at a specific location
 */
export const getStockItemsAtLocation = (locationCode: string) => {
  return stockItemsCache.filter(item => item.locationCode === locationCode);
};

/**
 * Helper function to get total value at a location
 */
export const getTotalValueAtLocation = (locationCode: string): number => {
  const items = getStockItemsAtLocation(locationCode);
  return items.reduce((sum, item) => sum + (item.value || 0), 0);
};

/**
 * Helper function to get item count at a location
 */
export const getItemCountAtLocation = (locationCode: string): number => {
  return getStockItemsAtLocation(locationCode).length;
};
